import { makeStyles } from '@material-ui/core/styles';
import { vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const numberInputFieldStyles = makeStyles(_theme => ({
  paper: {
    width: '12.0vw',
    borderRadius: '25px',
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    "& input[type='number']::-webkit-inner-spin-button": {
      appearance: 'none',
      margin: 0,
    },
    "& input[type='number']::-webkit-outer-spin-button": {
      appearance: 'none',
      margin: 0,
    },
    '@media (aspect-ratio: 4/3)': {
      width: '16.0vw',
      borderRadius: '40px',
    },
    '@media (height: 576px)': {
      borderRadius: '40px',
    },
  },
  bigPaper: {
    width: '18.5vw',
    borderRadius: '2.3vw',
    boxShadow: `0 1px 4px 0 ${themeColor.almosttransparentblack}`,
    "& input[type='number']::-webkit-inner-spin-button": {
      appearance: 'none',
      margin: 0,
    },
    "& input[type='number']::-webkit-outer-spin-button": {
      appearance: 'none',
      margin: 0,
    },
    '@media (aspect-ratio: 4/3)': {
      width: '18.5vw',
      borderRadius: '40px',
    },
    '@media (height: 576px)': {
      borderRadius: '40px',
    },
  },
  inputRoot: {
    height: '100%',
  },
  inputField: {
    textAlign: 'center',
    fontSize: vw(1.42),
  },
  circular: {
    width: '1vw',
    height: '5.75vh',
    minWidth: '5.75vh',
    background: themeColor.primaryMain,
    color: themeColor.white,
    '&:hover': {
      backgroundColor: themeColor.primaryMain,
    },
    '&.Mui-disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: 1,
    },
  },
  bigCircular: {
    width: '5.5vw',
    height: '5.5vw',
    minWidth: '5.75vh',
    background: themeColor.primaryMain,
    color: themeColor.white,
    '&:hover': {
      backgroundColor: themeColor.primaryMain,
    },
    '&.Mui-disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: 1,
    },
  },
  addRemove: {
    '&.MuiSvgIcon-root': {
      height: '2em',
      width: '2em',
    },
  },
}));
